// @flow
import { Map } from 'immutable';
import Constants from '../../constants';
import { ACTION_SUCCESS } from '../../constants/action-status';
import type { Action } from '../../actions/types';

export const DEFAULT_STATE = Map({
	isOpen: false,
	url: '',
});

export default function shareDialogReducer(state: Map<any, any> = DEFAULT_STATE, action: Action) {
	switch (action.type) {
		case `${Constants.OPEN_SHARE_DIALOG}_${ACTION_SUCCESS}`:
			return state.withMutations((state) => {
				state.set('isOpen', true);
				state.set('url', action.params.url);
			});
		case `${Constants.CLOSE_SHARE_DIALOG}_${ACTION_SUCCESS}`:
			return state.withMutations((state) => {
				state.set('isOpen', false);
				state.set('url', '');
			});
		default:
			return state;
	}
}
